import { render } from "./VendorKcorPoc.vue?vue&type=template&id=45bc6d5e"
import script from "./VendorKcorPoc.vue?vue&type=script&lang=js"
export * from "./VendorKcorPoc.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__